<template>
  <div class="offline-status">
    <h2>{{ mainText }} {{ appState$$?.offlineYear }}</h2>
    <h3>{{ appState$$?.offlineText }}</h3>
  </div>
</template>

<script setup>
// #region VUE
import {inject, computed} from 'vue';
import {useStore} from 'vuex';
// #endregion

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');
const store = useStore();
const mainText = computed(() => store.getters['text/getSectionTexts']('main'));
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

// Scoped styles
.offline-status{
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 4rem;
  & h3 {
    color: #777;
    font-size: 18px;
    font-weight: lighter;
    padding: 0 2rem;
    text-align: center;
  }
}
</style>
